import { getCampaignPeriodDateTime } from 'utils/TimeFormatUtil';
import { APIStatus, LanguageConfig } from '../config/CustomEnums';
import {
  getMaintenance,
  updateMaintenance,
} from '../services/MaintenanceAPIHelper';
import { loading } from './LoadingUtil';

const getInitialState = () => ({
  maintenanceDetail: {},
  loadingStatus: APIStatus.none,
  formHasSubmitted: false,
  hasUpdatedDefaultValues: false,
});

const parseTranslations = (data) => {
  if (!data.translations) {
    return {};
  };
  const translation = {};
  translation[LanguageConfig.english] = {
    title: data.title,
    description: data.description,
  };
  data.translations.forEach((item) => {
    const language = item.language;
    translation[language] = {
      language,
      title: item.title,
      description: item.description,
    };
  });
  return translation;
};

const parseMaintenance = (data) => {
  let displayHour = 0;
  let displayMinute = 0;
  if (data.active && data.startActiveTime) {
    const targetTime = new Date(data.startActiveTime);
    const now = new Date();

    const difference = now - targetTime;
    if (difference > 0) {
      displayHour = Math.floor(difference / (1000 * 60 * 60));
      displayMinute = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    }
  }

  return {
    active: data.active,
    startActiveTime: data.startActiveTime,
    displayHour,
    displayMinute,
    displayStartActiveTime: data.startActiveTime ? getCampaignPeriodDateTime(data.startActiveTime) : null,
    translations: parseTranslations(data),
  };
};

const parseInputBody = (values, originalValues) => {
  const translations = [];
  const translationArray = Object.keys(values.translations || {});
  translationArray.forEach((language) => {
    if (language === LanguageConfig.english) {
      return;
    }
    translations.push({
      ...values.translations[language],
      language: language,
    });
  });

  let startActiveTime = originalValues.startActiveTime;
  if (!values.active) {
    startActiveTime = null;
  }
  else if (values.active && !originalValues.active) {
    startActiveTime = new Date();
  };

  const inputBody = {
    active: values.active,
    startActiveTime,
    title: values.translations?.[LanguageConfig.english]?.title,
    description: values.translations?.[LanguageConfig.english]?.description,
    translations: translations,
  };
  return inputBody;
};

export default {
  namespace: 'maintenance',
  state: getInitialState(),
  reducers: {
    updateState(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    resetStatus(state, { payload }) {
      return {
        ...state,
        formHasSubmitted: false,
        hasUpdatedDefaultValues: false,
      }
    },
  },
  effects: {
    getMaintenance: [
      function* ({ payload }, { put }) {
        yield put({
          type: 'updateState',
          payload: {
            loadingStatus: APIStatus.calling,
          },
        });
        const serviceArgs = [getMaintenance];

        function* onSuccess(data) {
          const maintenanceData = data.maintenance || {};
          const maintenanceDetail = parseMaintenance(maintenanceData);
          yield put({
            type: 'updateState',
            payload: {
              maintenanceDetail: maintenanceDetail,
              loadingStatus: APIStatus.success,
              hasUpdatedDefaultValues: true,
            },
          });
        }
        yield loading(serviceArgs, onSuccess);
      },
      { type: 'takeLatest' },
    ],
    updateMaintenance: [
      function* ({ payload }, { select, put }) {
        const maintenanceDetail = yield select((state) => state.maintenance.maintenanceDetail);
        const values = payload.values;
        const inputBody = parseInputBody(values, maintenanceDetail);
        const serviceArgs = [updateMaintenance, inputBody];

        function* onSuccess() {
          yield put({
            type: 'updateState',
            payload: {
              formHasSubmitted: true,
            },
          });
          const afterActions = payload.afterActions || (() => { });
          yield afterActions();

          yield put({ type: 'getMaintenance', payload: {} });
        }
        yield loading(serviceArgs, onSuccess);
      },
      { type: 'takeLatest' },
    ],
  },
};
